// You can write more code here

/* START OF COMPILED CODE */

import EditorMarker from "../../level/EditorMarker";
/* START-USER-IMPORTS */
import { CharacterSkinsValues } from './../../CharacterSpine';
/* END-USER-IMPORTS */

export default class SimpleBreakableBlocker {

  constructor(gameObject: EditorMarker) {
    this.gameObject = gameObject;
    (gameObject as any)["__SimpleBreakableBlocker"] = this;

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */

    // custom definition props
    this.allowedCharacter = "grizz";
  }

  static getComponent(gameObject: EditorMarker): SimpleBreakableBlocker {
    return (gameObject as any)["__SimpleBreakableBlocker"];
  }

  private gameObject: EditorMarker;

  /* START-USER-CODE */

  public allowedCharacter: CharacterSkinsValues;

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
